import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Twitter, Github } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 border-t border-white/5 bg-[#050505] mt-0"
    >
      <div className="px-6 md:px-12 lg:px-16 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          {/* Brand block */}
          <div className="md:col-span-5">
            <h3
              className="font-serif-display text-4xl md:text-5xl text-white font-light leading-tight"
              style={{ letterSpacing: "-0.02em" }}
            >
              Build the platform <br />
              your roadmap deserves<span style={{ color: "#C2533B" }}>.</span>
            </h3>
            <p className="mt-6 text-zinc-400 text-base max-w-md leading-relaxed">
              Elite Solutions Hub partners with mid-market and enterprise organisations to architect,
              build, and operate the systems that define the next decade of their business.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-start"
              className="btn-primary mt-8"
            >
              Start a Conversation <ArrowUpRight size={14} strokeWidth={1.8} />
            </Link>
          </div>

          {/* Sitemap */}
          <div className="md:col-span-2">
            <p className="overline mb-6">Company</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="text-zinc-400 hover:text-white transition" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/careers" className="text-zinc-400 hover:text-white transition" data-testid="footer-link-careers">Careers</Link></li>
              <li><Link to="/insights" className="text-zinc-400 hover:text-white transition" data-testid="footer-link-insights">Insights</Link></li>
              <li><Link to="/case-studies" className="text-zinc-400 hover:text-white transition" data-testid="footer-link-cases">Case Studies</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="overline mb-6">Services</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/services" className="text-zinc-400 hover:text-white transition">Custom Software</Link></li>
              <li><Link to="/services" className="text-zinc-400 hover:text-white transition">Cloud & DevSecOps</Link></li>
              <li><Link to="/services" className="text-zinc-400 hover:text-white transition">AI & Data</Link></li>
              <li><Link to="/services" className="text-zinc-400 hover:text-white transition">Dedicated Teams</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-6">Contact</p>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li>
                <a
                  href="mailto:info@elitesolutionshub.com"
                  className="hover:text-white transition"
                  data-testid="footer-email-link"
                >
                  info@elitesolutionshub.com
                </a>
              </li>
              <li>elitesolutionshub.com</li>
              <li className="pt-4">
                <p className="overline mb-3">Headquarters</p>
                <p>London, United Kingdom</p>
                <p className="mt-1 text-zinc-600 text-xs">Elite Solutions Hub Ltd. · Registered in England &amp; Wales</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-xs text-zinc-500">
            © {year} Elite Solutions Hub Ltd. All rights reserved. · Registered in England &amp; Wales.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-zinc-500 hover:text-white transition" aria-label="LinkedIn" data-testid="footer-social-linkedin">
              <Linkedin size={16} strokeWidth={1.5} />
            </a>
            <a href="#" className="text-zinc-500 hover:text-white transition" aria-label="Twitter">
              <Twitter size={16} strokeWidth={1.5} />
            </a>
            <a href="#" className="text-zinc-500 hover:text-white transition" aria-label="GitHub">
              <Github size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
